import { render, staticRenderFns } from "./BallotCheckIcon.vue?vue&type=template&id=aa955fb8&"
import script from "./BallotCheckIcon.vue?vue&type=script&lang=ts&"
export * from "./BallotCheckIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports